var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.413 17H20.587M13.413 17L11.5 21M13.413 17L16.2783 11.009C16.5092 10.5263 16.6246 10.2849 16.7826 10.2086C16.9199 10.1423 17.0801 10.1423 17.2174 10.2086C17.3754 10.2849 17.4908 10.5263 17.7217 11.009L20.587 17M20.587 17L22.5 21M2.5 5H8.5M8.5 5H12M8.5 5V3M12 5H14.5M12 5C11.5039 7.95729 10.3526 10.6362 8.66555 12.8844M10.5 14C9.88747 13.7248 9.26265 13.3421 8.66555 12.8844M8.66555 12.8844C7.31302 11.8478 6.10276 10.4266 5.5 9M8.66555 12.8844C7.06086 15.0229 4.97143 16.7718 2.5 18",
    stroke: "#cda742",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/Languages.a1629ebefc3bf47e2dfee9cdd04d4195.svg";
export { ForwardRef as ReactComponent };